var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSuccess(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Groupe_1065",
    "data-name": "Groupe 1065",
    xmlns: "http://www.w3.org/2000/svg",
    width: 49.249,
    height: 49.249,
    viewBox: "0 0 49.249 49.249",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_634",
    "data-name": "Trac\\xE9 634",
    d: "M24.625,0A24.625,24.625,0,1,1,0,24.625,24.625,24.625,0,0,1,24.625,0Z",
    fill: "#afffd7"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_395",
    "data-name": "Path 395",
    d: "M355.549,389.309a2.808,2.808,0,0,1-1.689-.561l-.03-.023-6.362-4.866a2.827,2.827,0,1,1,3.44-4.487l4.12,3.16,9.737-12.7a2.826,2.826,0,0,1,3.962-.523h0l-.06.084.062-.084a2.829,2.829,0,0,1,.523,3.963L357.8,388.2a2.827,2.827,0,0,1-2.249,1.1Z",
    transform: "translate(-333.474 -354.391)",
    fill: "#218051"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuccess);
export default __webpack_public_path__ + "static/media/success.6afdc00a7fd3cc862289bb566cf8d4c6.svg";
export { ForwardRef as ReactComponent };